import PartnersReviews, { PartnersReviewsProps } from "./PartnersReviews";

export { PartnersReviewsProps };
export default PartnersReviews;
